<template>
    <van-dialog v-model="show" title="货款录入" show-cancel-button @close="onDialogClose" @confirm="onSubmit"
        :beforeClose="onBeforeClose" @open="doQuery">
        <van-form style="min-height: 2.5rem;" label-width="1.8rem">
            <!-- <van-form> -->
            <van-field v-model="amount" type="number" name="amount" label="货款金额" placeholder="请输入货款金额"
                :error-message="amountErrorMsg" />
            <van-field name="payType" label="支付方式">
                <template #input>
                    <van-radio-group v-model="payType" direction="horizontal">
                        <!-- <van-radio name="CashPay">现金支付</van-radio> -->
                        <van-radio name="AllinpayScanPayBSC">微信扫码</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-model="remark" type="textarea" name="remark" label="备注" placeholder="请输入备注" />
        </van-form>
    </van-dialog>
</template>

<script>
export default {
    model: {
        prop: 'isShow',
        event: 'change'
    },
    props: {
        isShow: Boolean,
        /**
         * 扩展表单数据
         */
        extendFormData: Object
    },
    data() {
        return {
            show: false,
            amount: null,
            //payType: 'CashPay',
            payType: 'AllinpayScanPayBSC',
            // 错误信息
            amountErrorMsg: '',
            createOrderJson: null,
            OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
            remark: ''
        }
    },
    watch: {
        isShow(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        // 取消默认关闭弹框事件
        onBeforeClose(action, done) {
            if (action == 'confirm') {
                return done(false);
            }
            return done(true);
        },
        onDialogClose() {
            this.$emit('change', this.show);
        },
        onSubmit() {
            // 填写了才判断  ^\d+(\.\d{1,2})?$ 最多两位小数
            var regex = /^\d+(\.\d{1,2})?$/;
            if (!regex.test(this.amount)) {
                this.amountErrorMsg = '请输入最多包含两位小数的数字';
            } else {
                this.amountErrorMsg = ''
                //创建货款订单
                let PassengerJsonText = [
                    {
                        TicketType: 9,
                        CustName: "货款",
                        CustTel: null,
                        CustCertType: "其它",
                        CustCertNo: "",
                        IsChild: false,
                        ChildName: null,
                        ChildCertType: null,
                        ChildCertNo: null,
                        SeatNo: 0,
                        TicketPrice: this.amount,
                        Remark: this.remark
                    },
                ];
                let params = {
                    AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
                    LineClassDayGID: this.extendFormData.LineClassDayGID,
                    StartNodeGID: this.extendFormData.StartNodeGID,
                    //下车点在订单创建时默认最后一个可售下车点
                    ArrivalNodeGID: "",
                    PassengerJsonText: JSON.stringify(PassengerJsonText),
                    ContactName: "货款",
                    ContactTel: null,
                    OrderTypeID: 5,
                    WeiXinOpenID: null,
                    WeiXinAppID: null,
                    OperGID: this.OperObj.GID, //操作员GID
                    OperCode: this.OperObj.UserCode, //操作员代码
                    OperName: this.OperObj.UserName, //操作员名称
                };
                this.createOrderJson = params;
                //如果是扫码，先扫码再创建订单，防止扫码失败重复创建订单
                if (this.payType == 'CashPay') {
                    this.toCreatOrder()
                } else {
                    this.onSacnQRCode()
                }
            }

        },
        toCreatOrder(payCode) {
            this.$http
                .post(this.$api.createTicketOrder, this.$qs.stringify(this.createOrderJson))
                .then((res) => {
                    if (res.success) {
                        this.$toast("订单创建成功");
                        this.ticketOrderPayDo(
                            this.payType,
                            res.data[0].OrderNo,
                            payCode
                        );
                    } else {
                        this.$dialog.alert({
                            title: "提示",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => { });
        },
        //唤起扫码
        onSacnQRCode() { //调起摄像头扫码
            var that = this;
            if (window.framework && window.framework.jsCameraScan) {
                this.$emit('child-value', this.amount);
                window.framework.jsCameraScan();
            } else {
                if (this.$utils.getIsWxClient()) {
                    wx.ready(function () {
                        wx.scanQRCode({
                            needResult: 1,
                            scanType: ["qrCode"],
                            success: function (t) {
                                that.toCreatOrder(t.resultStr);
                            },
                            fail: function (e) {
                                alert(e);
                            },
                        });
                    });
                } else {
                    this.$toast("调起扫码失败，请检查设备！");
                    return;
                }
            }
        },
        // 支付订单
        ticketOrderPayDo(PayTypeCode, OrderNo, payCode) {
            let params = {
                PayTypeCode: PayTypeCode,
                OrderNo: OrderNo,
                OperGID: this.OperObj.GID, //操作员GID
                OperCode: this.OperObj.UserCode, //操作员代码
                OperName: this.OperObj.UserName, //操作员名称
            };
            this.$http
                .post(
                    this.$api.onTicketOrderPayDo,
                    this.$qs.stringify({
                        model: params,
                        authcode: payCode,
                    })
                )
                .then((res) => {
                    if (res.success) {
                        this.$toast("出票成功");
                        //隐藏
                        this.show = false;
                    } else {
                        this.$toast("出票失败");
                    }
                })
                .catch((err) => {

                });
        },
        // 信息查询
        doQuery() {

        }
    }
}
</script>

<style lang="less" scoped></style>